import { Link } from 'react-router-dom';
import './speaking.css';
import Header from '../components/Navbar/Navbar.js';
import Footer from '../components/Footer/Footer.js';
import Seo from '../components/Seo';
import { images } from '../config/imagePaths';

function PublicSpeaking() {
  return (
    <div className="speaking-page">
      <Seo
        title="Public Speaking"
        description="Professional public speaking training and services from AOK Communications."
      />
      <Header />

     <main className="web-main page-content">
        <section className="split-section reveal-left">
          <div className="split-text">
            <div>
              <h2>Speak with Impact</h2>
              <p>Gain confidence to deliver your message with clarity and purpose in every setting.</p>
            </div>
            <div>
              <h2>Grow Beyond Your Comfort Zone</h2>
              <p>Explore practical techniques that turn stage fright into enthusiasm and connection, no matter the audience size.</p>
            </div>
            <div>
              <h2>Connect Authentically</h2>
              <p>We teach you to move beyond nerves and truly connect with your audience.</p>
            </div>
          </div>
          <div className="split-image-wrap img-zoom-wrap reveal-right">
            <img src={images.services.publicSpeaking} alt="Speaking Example" className="split-image" />
          </div>
        </section>

        <section className="tiles-background reveal-scale">
          <div className="speaking-services stagger-children">
            <div className="service-basic hover-lift">
              <h3>Individual Session</h3>
              <p>A focused 40-minute 1:1 session tailored for your next presentation.</p>
            </div>
            <div className="service-alt hover-lift">
              <div>
                <h3>Group Sessions</h3>
                <p>For 2–10 people. Choose from:</p>
                <ul>
                  <li>One-off Workshop</li>
                  <li>4-Week Course</li>
                  <li>6-Week Course</li>
                </ul>
              </div>
            </div>
            <div className="highlight-course hover-lift">
              <h3>6-Week Individual Course</h3>
              <p>Our crash course on speaking with clarity and impact.</p>
              <ul>
                <li>Public Speaking Fundamentals</li>
                <li>Body Language</li>
                <li>Pacing & Tone</li>
                <li>Confidence & Structure</li>
              </ul>
            </div>
          </div>
        </section>

        <section className="web-section center reveal" style={{ marginTop: '50px' }}>
          <div className="web-text">
            <h2>Let’s empower your voice together.</h2>
            <Link to="/contact" className="contact-button hover-lift">Get In Touch</Link>
          </div>
        </section>
      </main>

     <Footer />
    </div>
  );
}

export default PublicSpeaking;
